export default __webpack_public_path__ + "static/media/gallery_08.e3d913f3.jpg";